export default __webpack_public_path__ + "roboto-v27-latin-regular.69358f64aea6fd09499aacb2bae24f53.ttf";